var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14a1 1 0 011 1v6.5a.5.5 0 01-.5.5H21a.5.5 0 01-.5-.5V16a.5.5 0 00-.5-.5H4a.5.5 0 00-.5.5v5.5a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5V15a1 1 0 011-1h18zM12.51 8.886c3.268.134 4.928 1.617 5.771 3.089.274.477-.108 1.025-.658 1.025-.304 0-.576-.177-.737-.435a4.227 4.227 0 00-.566-.721c-.73-.745-1.993-1.468-4.297-1.468-2.305 0-3.569.723-4.298 1.468-.224.228-.41.472-.565.721a.883.883 0 01-.736.435c-.55 0-.931-.547-.658-1.024.883-1.544 2.664-3.1 6.257-3.1l.487.01z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.206 1.005c1.884.094 3.382 1.622 3.382 3.495l-.005.18c-.096 1.85-1.653 3.32-3.56 3.321l-.183-.005c-1.823-.09-3.285-1.526-3.377-3.315L8.458 4.5c0-1.933 1.597-3.5 3.565-3.5l.183.005zM12.023 2.5c-1.166 0-2.065.921-2.065 2s.9 2 2.065 2.001c1.167 0 2.065-.922 2.065-2.001 0-1.079-.899-2-2.065-2z",
    fill: "currentColor"
  })));
}
SvgLobby.displayName = 'Lobby';
export default SvgLobby;